<template>
  <div id="timer" :style="{ fontSize: fontSize }" role="timer">
    {{ elapsedTimeStr }} 
    
  </div>
</template>

<script>
export default {
  props: {
    referenceTime: {
      type: Number,
      required: true,
    },
    isCountDown: {
      type: Boolean,
    },
    size: {
      type: String,
    },
    elapsedTimeFormater: {
      type: Function,
      required: true,
    },
    saveProgress: {
      type: Boolean,
      default: false,
    },
    completeTime: {
      type: Number,
      default: null,
    },
    referenceName: {
      type: String,
    },
  },
  data() {
    return {
      elapsed: 0,
      timerId: null,
    };
  },
  computed: {
    fontSize() {
      return this.size ? this.size : "18px";
    },
    isCompleted() {
      // if still active end time would still be null so complete time is endtime - starttime which is
      // just 0 - starttime
      if(this.referenceTime == null) {
        return false
      }
      return (
        Math.abs(this.completeTime) !== this.referenceTime &&
        this.completeTime !== null
      );
    },
    elapsedTimeStr() {
      if (this.isCompleted) {
        return this.elapsedTimeFormater(Math.floor(this.completeTime / 1000));
      }
      return this.elapsedTimeFormater(this.elapsed);
    },
  },
  methods: {
    getElapsedTime() {
      return Date.now() - this.referenceTime;
    },
    startTimer() {
      this.updateTimer();
    },
    updateTimer() {
      if (this.isCountDown && Date.now() >= this.referenceTime) {
        cancelAnimationFrame(this.timerId);
      } else {
        this.elapsed = Math.floor(
          Math.abs(Date.now() - this.referenceTime) / 1000
        );
        this.timerId = requestAnimationFrame(this.updateTimer);
      }
    },
    pauseTimer() {
      cancelAnimationFrame(this.timerId);
    },
    emitElapsed() {
      this.pauseTimer();
      this.$emit("set-elapsed", this.getElapsedTime());
    },
    handleVisibilityChange() {
      if (this.isCompleted) {
        return;
      }
      if (document.visibilityState === "hidden") {
        this.emitElapsed();
      }
    },
  },
  mounted() {
    this.startTimer();
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
    window.addEventListener("beforeunload", this.emitElapsed);
  },
  beforeUnmount() {
    this.pauseTimer();
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("beforeunload", this.emitElapsed);
  },
};
</script>

<style scoped>
* {
  user-select: none;
  font-weight: bold;
  font-size: 18px;
  font-family: "Fira Sans", system-ui;
  font-variant-numeric: tabular-nums;
}
</style>
